import { useEffect } from "react";
import { useStoreSelector } from "../../store";
const FreshdeskWidgetComponent = () => {
  const loggedInUser = useStoreSelector((state) => state.AppReducer.user);
  useEffect(() => {
    const loadScript = (src, position, id) => {
      if (!document.getElementById(id)) {
        const script = document.createElement("script");
        script.setAttribute("src", src);
        script.setAttribute("async", "");
        script.setAttribute("defer", "");
        script.id = id;
        position.appendChild(script);
      }
    };
    window.fwSettings = {
      widget_id: 202000000921,
      locale: loggedInUser.language
    };
    !(function() {
      if ("function" !== typeof window.FreshworksWidget) {
        const n = function() {
          n.q.push(arguments);
        };
        n.q = [];
        window.FreshworksWidget = n;
      }
    })();
    loadScript("https://euc-widget.freshworks.com/widgets/202000000921.js", document.body, "freshworks-widget-script");
    window.FreshworksWidget("identify", "ticketForm", {
      name: loggedInUser?.personName.fullName,
      email: loggedInUser?.emailAddress
    });
    window.FreshworksWidget("disable", "ticketForm", ["name", "email"]);
    return () => {
      const script = document.getElementById("freshworks-widget-script");
      if (script) {
        script.remove();
      }
      window.FreshworksWidget = void 0;
    };
  }, [
    loggedInUser?.emailAddress,
    loggedInUser.fullName,
    loggedInUser.language,
    loggedInUser.name,
    loggedInUser?.personName.fullName
  ]);
  return null;
};
export default FreshdeskWidgetComponent;
